import { Component, inject, Input, OnInit } from '@angular/core';

import { CurrentUserService } from '../../../../../../services/current-user.service';
import { SPEND_TYPES } from 'src/app/framework/constants/spend.constants';
import { MONTHS_LOWERCASE } from '@app/framework/constants/view.constants';
import { DeepCopyService } from '@app/services/deep-copy.service';

@Component({
  selector: 'app-budget-line-item-table-header',
  imports: [],
  templateUrl: './budget-line-item-table-header.component.html',
  styleUrl: './budget-line-item-table-header.component.scss',
})
export class BudgetLineItemTableHeaderComponent implements OnInit {
  protected readonly userService = inject(CurrentUserService);

  protected readonly SPEND_TYPES = SPEND_TYPES;
  @Input({ required: true }) selectedBudgetType: SPEND_TYPES;
  MONTHS = DeepCopyService.deepCopy(MONTHS_LOWERCASE);

  ngOnInit() {
    this.setMonths();
  }

  setMonths() {
    let fyStart = this.userService.data.fiscal_year_start;

    if (fyStart) {
      fyStart = fyStart - 1;
      for (let i = 0; i < fyStart; i++) {
        const aux = this.MONTHS[0];
        this.MONTHS.shift();
        this.MONTHS.push(aux);
      }
    }
  }
}
